export default {
    organizationOrders: {},
    eventOrders: {}
}